<template>
    <page>
        <module enable-flex>
            <view-list ref="view" class="flex-grow" :work-type="workType" :view-config="saasInfo.viewmanage" @load="loadStats">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="采购部门">
                            <c-select name="purchase_dept_id" async  @search="searchDepartment"></c-select>
                        </m-search-item>
                        <m-search-item label="采购人">
                            <c-select name="purchase_user_id" async  @search="searchUser('1', arguments[0], arguments[1])"></c-select>
                        </m-search-item>
                        <m-search-item label="供应商">
                            <c-select name="supplier_id" async  @search="searchSupplier" v-model="supplierId"></c-select>
                        </m-search-item>
                        <m-search-item label="供应商联系人">
                            <c-select name="supplier_contact_id" async  @search="searchUser('2', arguments[0], arguments[1])"></c-select>
                        </m-search-item>
                        <m-search-item label="采购单号">
                            <c-input name="purchase_code"></c-input>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>

                    <!-- 采购账单汇总统计 -->
                    <div class="stats-bar flex">
                        <div class="stats-card card-blue">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">回收总数</span>
                                    <span class="stats-value">{{ formatNumber(stats.recycle_total_count) }}</span>
                                </div>
                                <div class="stats-summary-row flex-start-center">
                                    <span><label>入库数：</label>{{ formatNumber(stats.instorage_total_count) }}</span>
                                    <ins>|</ins>
                                    <span><label>退库数：</label>{{ formatNumber(stats.out_storage_total_count) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon"><i class="tf tf-phone"></i></div>
                        </div>
                        <div class="stats-card card-orange">
                            <div class="stats-info">
                                <div class="stats-title-row flex-start-center">
                                    <span class="stats-label">采购总金额</span>
                                    <span class="stats-value">￥{{ formatMoney(stats.total_purchase_amount) }}</span>
                                </div>
                                <div class="stats-summary-row flex-start-center">
                                    <span><label>待结算：</label>￥{{ formatMoney(stats.pending_amount) }}</span>
                                    <ins>|</ins>
                                    <span><label>已结算：</label>￥{{ formatMoney(stats.settled_amount) }}</span>
                                </div>
                            </div>
                            <div class="stats-icon">¥</div>
                        </div>
                    </div>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_purchase_bill_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!-- 采购渠道类型 -->
                <template #purchase_type="{data}">
                    <c-state async tag dict="PURCHASE_ORDER_TYPE" :value="data.purchase_type"></c-state>
                </template>
                <!-- 货款结算方 -->
                <template #payee_user_type="{data}">
                    <c-state async tag dict="PURCHASE_PAYEE_USER_TYPE" :value="data.payee_user_type"></c-state>
                </template>
                <!-- 结算状态 -->
                <template #settle_state="{data}">
                    <c-state async tag dict="PURCHASE_SETTLE_STATE" :value="data.settle_state"></c-state>
                </template>
                <!-- 结算金额 -->
                <template #settle_money="{data}">
                    <span v-if="data.settle_money" style="color: green">￥{{ data.settle_money || '-' }}</span>
                </template>
                <!-- 扣款金额 -->
                <template #deduct_money="{data}">
                    <span v-if="data.deduct_money" style="color: red">￥{{ data.deduct_money || '-' }}</span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="120"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="globalDialog('purchaseBillDetail', {props: {id: data.id}})">查看</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    components: {},

    data() {
        return {
            workType: 119,
            stats: {}
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo', 'memberTypeDic', 'completedDic'])
    },

    methods: {
        /*******搜索【供应商】下拉框信息*****************/
        searchSupplier(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SUPPLIER',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索部门*****************/
        searchDepartment(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'DEPARTMENT',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            });
        },
        /************搜索用户*******************************/
        searchUser(user_type, keyword, resolve) {
            let paramData = {
                user_type: user_type,
                options_code: 'SYSUSER',
                keyword: keyword
            };
            this.request({
                url: '/system/options',
                data: paramData,
                success: data => {
                    resolve(data);
                }
            })
        },
        /**
         * 加载采购账单汇总统计（随列表查询条件联动）
         */
        loadStats(listData, searchParams) {
            this.request({
                url: '/financial/purchase/bill/summary',
                data: searchParams || {},
                success: data => {
                    this.stats = data || {};
                }
            });
        },

        /**
         * 金额格式化（分/元统一按数值保留两位小数）
         */
        formatMoney(val) {
            if (val === undefined || val === null || val === '') {
                return '0.00';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0.00' : num.toFixed(2);
        },

        /**
         * 数量格式化
         */
        formatNumber(val) {
            if (val === undefined || val === null || val === '') {
                return '0';
            }
            const num = parseFloat(val);
            return isNaN(num) ? '0' : String(Math.round(num));
        }
    }
}
</script>

<style lang="stylus" scoped>
    .stats-bar {
        flex-shrink: 0;
        gap: 10px;
        border-top: 1px solid #F5F5F5;
        padding: 8px 12px;

        .stats-card {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex: 1;
            max-width: 360px;
            min-height: 56px;
            padding: 8px 16px;
            border-radius: 6px;
            color: #fff;
            box-sizing: border-box;
            overflow: hidden;

            &.card-blue {
                background: linear-gradient(90deg, #2563eb, #3b82f6);
            }

            &.card-orange {
                background: linear-gradient(90deg, #f97316, #fb923c);
            }

            .stats-info {
                position: relative;
                z-index: 1;

                .stats-title-row {
                    display: flex;
                    align-items: baseline;
                    line-height: 24px;

                    .stats-label {
                        font-size: 12px;
                        opacity: 0.95;
                    }

                    .stats-value {
                        margin-left: 6px;
                        font-size: 18px;
                        font-weight: bold;
                    }
                }

                .stats-summary-row {
                    gap: .5em;
                    margin-top: 2px;
                    font-size: 11px;

                    ins {
                        text-decoration: none;
                        opacity: 0.6;
                    }

                    label {
                        opacity: 0.9;
                    }
                }
            }

            .stats-icon {
                position: absolute;
                right: 14px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 32px;
                line-height: 1;
                opacity: 0.15;

                .tf {
                    font-size: 32px;
                }
            }
        }
    }
</style>